export const createRequestBody = (formValues) => {
    let tempRequestBody = null;
    let tempCountry = {
        sortname: formValues.country.id,
        name: formValues.country.value
    }
    let tempState = formValues.state.value
    let pfNumberList = stringToArray(formValues.pfNumber)
    tempRequestBody = {
        ...formValues,
        state: tempState,
        country: tempCountry,
        pfNumber: pfNumberList
    }
    return tempRequestBody
}

export const stringToArray = (string) => {
    let arrayList = []
    if (string !== null && string.length>0) {
        string.split(",").forEach((value) => {
            arrayList.push(value.trim())
        })
    }
    return arrayList
}